module.exports = __webpack_public_path__ + "img/sld_annunciator_t1_grey.dc017206.svg";